module.exports = __webpack_public_path__ + "static/media/googleIcon.bbe3a3e5.jpg";